export class WbClipboard {
  constructor() {}

  init() {
    return new Promise((resolve, reject) => {
      this.bindListeners();
      resolve();
    });
  }

  bindListeners() {
    const _this = this;
    document.querySelectorAll('.wb-clipboard')?.forEach((button) => {
      button?.addEventListener('click', _this.copyToClipboard.bind(_this));
    });
  }

  async copyToClipboard(e) {
    try {
      await navigator.clipboard.writeText(e?.target?.innerText || '');
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  }
}
